"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var styles_1 = require("@mui/material/styles");
var AccordionSummary_1 = __importDefault(require("atomicComponents/atoms/Accordion/AccordionSummary"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var AccordionSummaryRow = (0, styles_1.styled)(AccordionSummary_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: 0,
        transition: 'none',
        width: 'fit-content',
        ':hover': {
            '.MuiAccordionSummary-content': {
                transition: 'none',
                '> .sub-row': {
                    transition: 'none',
                    backgroundColor: theme.palette.roseQuartz.A100,
                    '> .stickyCell': { backgroundColor: theme.palette.roseQuartz.A100 },
                    cursor: 'pointer',
                },
            },
        },
        ' .MuiAccordionSummary-expandIconWrapper': {
            svg: { height: 16, width: 16, color: theme.palette.grey[300] },
            '&.Mui-expanded svg': { color: theme.palette.primary.contrastText },
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(AccordionSummaryRow, {
    icon: pro_solid_svg_icons_1.faCaretRight,
    edgePosition: 'start',
    disableGutters: true,
    expandedIconPosition: 90,
});
